import React, { useState } from 'react'
import { Box } from '@material-ui/core'
import { useStyles } from './Calculator.style'
import CalculatorForm from './CalculatorStates/CalculatorForm'
import CalculatorReport from './CalculatorStates/CalculatorReport'
import CalculatorSubmit from './CalculatorStates/CalculatorSubmit'
import { calculatorData } from './Calculator.data'
import {
  fiftyFiftyCalculation,
  flexiCalculation,
  monthlyLeasingCalculation,
  motorcycleCalculation,
  personalFinanceInstantCalculation,
  personalFinanceStandardCalculation,
  salesAndLeaseBackCalculation,
  signAndDriveCalculation,
  takhayerCalculation,
} from './CalculatorFunctions.utils'

const Calculator = (data) => {
  const [calculatorCurrentState, setCalculatorCurrentState] = useState('form')
  const [reportValues, setReportValues] = useState({})
  const styles = useStyles()

  const handleCalculatorState = (state) => {
    setCalculatorCurrentState(state)
  }

  const handleCalculate = (calculatorType, calculatorValues) => {
    switch (calculatorType) {
      case 'monthly': {
        const report = monthlyLeasingCalculation(calculatorValues)
        setReportValues(report)
        break
      }
      case '50-50': {
        const report = fiftyFiftyCalculation(calculatorValues)
        setReportValues(report)
        break
      }
      case 'sign-and-drive': {
        const report = signAndDriveCalculation(calculatorValues)
        setReportValues(report)
        break
      }
      case 'flexi': {
        const report = flexiCalculation(calculatorValues)
        setReportValues(report)
        break
      }
      case 'sale-and-leaseback': {
        const report = salesAndLeaseBackCalculation(calculatorValues)
        setReportValues(report)
        break
      }
      case 'motorcycle': {
        const report = motorcycleCalculation(calculatorValues)
        setReportValues(report)
        break
      }
      case 'takhayer': {
        const report = takhayerCalculation(calculatorValues)
        setReportValues(report)
        break
      }
      case 'personal-finance-standard': {
        const report = personalFinanceStandardCalculation(calculatorValues)
        setReportValues(report)
        break
      }
      case 'personal-finance-instant': {
        const report = personalFinanceInstantCalculation(calculatorValues)
        setReportValues(report)
        break
      }
      case 'self-employed': {
        const report = monthlyLeasingCalculation(calculatorValues)
        setReportValues(report)
        break
      }
      default:
    }
  }

  let calculatorState = ''
  if (calculatorCurrentState === 'form') {
    calculatorState = (
      <CalculatorForm
        handleState={handleCalculatorState}
        handleCalculate={handleCalculate}
        type={data.type}
        t={data.t}
      />
    )
  }
  if (calculatorCurrentState === 'report') {
    calculatorState = (
      <CalculatorReport
        handleState={handleCalculatorState}
        reportValues={reportValues}
        type={calculatorData[data.type].reportType}
        t={data.t}
        location={data.location}
        calculatorType={data.type}
      />
    )
  }
  if (calculatorCurrentState === 'submit') {
    calculatorState = (
      <CalculatorSubmit
        t={data.t}
        handleState={handleCalculatorState}
        handleCalculatorState={handleCalculatorState}
      />
    )
  }

  return <Box className={styles.rootContainer}>{calculatorState}</Box>
}

export default Calculator
